// Integration of Verisoul fraud detection
export const loadVeriSoul = async (env, project_id, customDomain) => {
    return new Promise((resolve, reject) => {
        console.info('loadVeriSoul invoked');
        const veriSoulSrc = `https://${customDomain}/${env}/bundle.js`;
        let scriptCode = document.createElement('script');
        scriptCode.async = true;
        scriptCode.setAttribute('verisoul-project-id', project_id);
        scriptCode.setAttribute('src', veriSoulSrc);
        scriptCode.setAttribute('type', 'text/javascript');

        let meta = document.createElement('meta');
        meta['http-equiv'] = 'Content-Security-Policy';
        //meta['content'] = `script-src 'self' https://js.verisoul.ai https://${customDomain}; worker-src 'self' blob: data:; connect-src 'self' https://*.verisoul.ai wss://*.verisoul.ai https://${customDomain};`;
        meta['content'] = `script-src 'self' https://${customDomain}; worker-src 'self' blob: data:; connect-src 'self' wss://*.verisoul.ai https://${customDomain};`;
        document.head.insertBefore(meta, document.head.firstElementChild);
        let loadScript = document.body;
        loadScript.insertBefore(scriptCode, loadScript.firstElementChild);
        if (scriptCode.readyState) {  // only required for IE <9
            scriptCode.onreadystatechange = async () =>{
                if (scriptCode.readyState === "loaded" || scriptCode.readyState === "complete") {
                    scriptCode.onreadystatechange = null;
                    await login();
                }
            };
        } else {  //Others
            scriptCode.onload = async () => {
                await login();
            };
        }

        const login = async () => {
            try {
                //session_id for uniquely identifying the user
                const startTime = Date.now();
                const session_id = await window.Verisoul.session();
                const endTime = Date.now();
                const verisoulGetSessionTime = (endTime - startTime) / 1000;

                if(!session_id) {
                    throw new Error('VeriSoul get Session Id not Found.');
                }

                resolve({ session_id: session_id.session_id, verisoulGetSessionTime: verisoulGetSessionTime });
                // pass session_id to backend
            } catch (e) {
                console.log('Verisoul failed get session_id', e);
                reject(e);
            }
        }
    });
}